import styled from 'styled-components';

import { Heading } from 'common/typography';

export const CalendarCaptionHeading = styled(Heading)`
  font-size: 22px;
  display: table-caption;
`;
